import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "icon", "text"];

  copy(event) {
    event.stopPropagation();
    event.preventDefault();
    navigator.clipboard.writeText(this.sourceTarget.textContent);
    if (this.hasIconTarget) {
      this.iconTarget.classList.replace("copy", "check");
    }
    if (this.hasTextTarget) {
      this.textTarget.innerText = "Copied";
      this.textTarget.classList.add("copied");
    }
  }
}
